// Runtime constants, not just types: the preload only links @griply/types, so they must live here rather than @griply/utils.
export const ELECTRON_USER_AGENT_MARKER = 'GriplyDesktop';
export const ELECTRON_APP_VERSION_META_NAME = 'app-version';
// Deep-link scheme web builds its hand-off URL with; must stay equal to the shell's VITE_APP_PROTOCOL.
export const ELECTRON_APP_PROTOCOL = 'griply';
